module.exports = __webpack_public_path__ + "static/media/SG-SNI1_1GD0L15_EP_zsxG8I7yC_4iCSD7PDhbh_.2f1e4939.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/SG-SNI1_1GD0L15_EP_zsxG8I7yC_4iCSD7PDhbh_
// module id = 847
// module chunks = 0